import { useEffect, useState } from 'react';
import type { UseQueryExecute } from 'urql';
import { useTechnicalMessages } from '../useTechnicalMessages';

export const useRefetchTrigger = ({ refetch }: { refetch: UseQueryExecute }) => {
  // this is meant to only trigger a reload, when the count changes.
  const { technicalMessages } = useTechnicalMessages();
  const [count, setCount] = useState(0);

  // biome-ignore lint/correctness/useExhaustiveDependencies: ignore other deps
  useEffect(() => {
    if (technicalMessages.length !== count) {
      setCount(technicalMessages.length);
      refetch({ requestPolicy: 'cache-and-network' });
    }
  }, [technicalMessages]);
};
